<p-dialog header="Add Comment" [(visible)]="displayAddComment" class="shared-comments" [closable]="true"
  (onHide)="hideAddComment()" [modal]="true" [style]="{width: '50%'}" appendTo="body" [focusOnShow]="false">
  <ng-template pTemplate="content">
    <form *ngIf="commentForm" [formGroup]="commentForm">
      <div class="p-field p-formgrid p-grid">
        <!-- Category Dropdown -->
        <div class="p-col-6">
          <label class="p-mb-1" for="category">Select Category</label>
          <p-dropdown id="category" placeholder="Choose Category" appendTo="body" [options]="wbCommentCategories"
            optionLabel="name" formControlName="category"
            [ngClass]="{ 'p-invalid': commentForm.get('category')?.invalid && commentForm.get('category')?.touched }"
            (onChange)="onCategoryChange($event)" [filter]="true">
            >
          </p-dropdown>
          <small class="p-invalid p-mt-1"
            *ngIf="commentForm.get('category')?.invalid && commentForm.get('category')?.touched">
            Please select a category.
          </small>
        </div>

        <!-- Subcategory Dropdown -->
        <div class="p-col-6" [ngClass]="{ 'p-d-none': subcategories.length === 0 }">
          <label class="p-mb-1" for="subcategory">Select Subcategory</label>
          <p-dropdown id="subcategory" placeholder="Choose Subcategory" appendTo="body" [options]="subcategories"
            optionLabel="name" formControlName="subcategory" [filter]="true"
            [ngClass]="{ 'p-invalid': commentForm.get('subcategory')?.invalid && commentForm.get('subcategory')?.touched }">
          </p-dropdown>
          <small class="p-invalid p-mt-1"
            *ngIf="commentForm.get('subcategory')?.invalid && commentForm.get('subcategory')?.touched">
            Please select a subcategory.
          </small>
        </div>
      </div>

      <!-- Comment Textarea -->
      <div class="p-field p-formgrid p-grid">
        <!-- <ul class="suggestion-list" *ngIf="showSuggestions">
          <li *ngFor="let user of filteredUsers" (click)="selectUser(user)">
            {{ user.name }}
          </li>
        </ul> -->
        <div class="p-col-12">
          <label class="p-mb-1" for="comment">Comments <span style="color: red;">*</span></label>
          <!-- <textarea id="comment"  rows="5" cols="30" placeholder="Enter your comment" formControlName="comment"
            pInputTextarea autoResize="autoResize" class="w-100"
            [ngClass]="{ 'p-invalid': commentForm.get('comment')?.invalid && commentForm.get('comment')?.touched }"
            >
      </textarea>-->
            <quill-editor
              placeholder="Enter your comment"
              [modules]="quillConfig"
              formControlName="comment"
             ></quill-editor>
          <div *ngIf="commentForm.get('comment')?.touched">
            <small *ngIf="commentForm.get('comment')?.errors?.['required']" class="p-error p-mt-1">
              Comment name is required.
            </small>

            <small *ngIf="commentForm.hasError('maxPlainTextLength') || commentForm.get('comment')?.errors?.['maxlength']" class="p-error p-mt-1">
              Comment length should be less than or equal to 1000.
            </small>

          </div>
        </div>
      </div>
     <div class="p-field p-formgrid p-grid">
  <div class="p-col-12">
    <label>
      Attachments
      <i class="pi pi-exclamation-circle" escape="false" [pTooltip]="multiLineTooltip" tooltipPosition="top"></i>
    </label>
    <p-fileUpload #fileUpload  [disabled]="isUploading" customUpload="true" mode="basic" chooseLabel="Choose"
      [showUploadButton]="false" [showCancelButton]="false" multiple="multiple"
      (onSelect)="uploadAttachments($event, fileUpload)">
    </p-fileUpload>
    <ng-container *ngIf="logTemp.log.logAttachments && (logTemp.log.logAttachments.length > 0)">
      <app-lion-attachment-chips [attachments]="logTemp.log.logAttachments"
          (removeAttachment)="removeAttachment($event)"></app-lion-attachment-chips>
  </ng-container>
  </div>
</div>


    </form>
  </ng-template>
  <p-footer>
    <button type="button" class="p-button-secondary" pButton (click)="hideAddComment()" label="Cancel"></button>
    <button type="submit" [disabled]="isUploading" pButton label="Save" (click)="onSubmit()"></button>
  </p-footer>
</p-dialog>

<div class="p-d-flex p-jc-end p-ai-center p-mb-3">
  <!-- <h4>Comments List</h4> -->
  <button icon="pi pi-refresh" pButton pRipple type="button" class="p-button-secondary p-button-text p-mr-2"
    (click)="getWBParentComment(rowNumber);" pTooltip="Refresh" tooltipPosition="top"
    [tooltipOptions]="{
      showDelay: 50,
      hideDelay: 50,
      positionStyle: 'fixed',
      appendTo: 'body'
    }"></button>  
  <p-button label="Add New Comment" (onClick)="openAddEditComment()"></p-button>

</div>
<div *ngIf="wbParentComments?.length === 0" class="no-comments-message p-d-flex p-jc-center p-ai-center p-mt-3">
  <p>No comments available. Be the first to add one!</p>
</div>
<p-card *ngFor="let comment of wbParentComments; let i = index;" class="activity-card" [ngClass]="{'unread-activity': comment?.hasUnReadComments===true || comment?.isRead===false}">
  <div class="p-d-flex cursor-pointer" (click)="openCommentDetail(comment, $event)">
    <div class="activity-icon p-shadow-3" [ngStyle]="{'background-color': comment?.categoryColor ?? '#ccc'}">
      <span class="pi pi-comment"></span>
    </div>
    <div class="activity-content">
      <ng-container>
        <h6 class="p-mb-1" style="display: inline-block;">
          <span *ngIf="comment?.categoryName">{{ comment?.categoryName }}</span> <span *ngIf="comment?.subCategoryName">
            - {{ comment?.subCategoryName }}</span>
          by {{ comment?.userName ?? 'Anonymous' }}
        </h6>
        <span class="p-ml-4">
          <span>{{ comment?.latestContentModifiedDate ? (comment?.latestContentModifiedDate | localDate:'dateTime') : 'No Date Available' }}</span>
        </span>
        <!-- <span class="p-ml-4" style="opacity: 0.8;" *ngIf="comment.updatedDate != null">
          (last modified: {{comment.updatedDate | localDate}})
      </span> -->
        <div [innerHtml]="comment?.latestContent"></div>
        <p *ngIf="comment.numberOfAttachment>0" class="p-mb-0 attachment-details"><i class="pi pi-paperclip p-mr-1"></i> {{comment.numberOfAttachment}} attachment{{comment.numberOfAttachment > 1 ? "'s" : ''}} added</p>
              <!-- <div
        class="description-cell"
        [innerHtml]="(comment?.content | stripHtml:true).length > 343
          ? (comment?.content | stripHtml:true | slice:0:343) + '...'
          : (comment?.content | stripHtml:true)"
      ></div> -->
      </ng-container>
    </div>
  </div>
</p-card>

<ng-container *ngIf="displayCommentDetailPopup">
  <app-workbook-comment-details [displayCommentDetailPopup]="displayCommentDetailPopup"
    [wbParentComment]="selectedParentComment" [workbookId]="workbookId" [rowNumber]="rowNumber"
    (hideCommentDetailsPopup)="hideCommentDetails()">
  </app-workbook-comment-details>
</ng-container>
<!-- <p-toast position="top-right" [baseZIndex]="1000000"></p-toast> -->
<ng-container *ngIf="displayUserDetails&&selectedUserId">
  <user-details-modal [display]="displayUserDetails" [selectedUserId]="selectedUserId"
  (close)="closeTaggedUserDetails()"></user-details-modal>
</ng-container>
<p-confirmDialog key="deleteComment" [style]="{ width: '20vw' }" [baseZIndex]="1000000"></p-confirmDialog>